module.exports = __webpack_public_path__ + "static/media/Tom Burkewitz‎ 01.9b53ca57.jpg";